const firebaseConfig = {
    apiKey: "AIzaSyAVD-MtYtS5ZGXnZGFXB5npoTZvYTFP9pc",
    authDomain: "assignment-11-999ed.firebaseapp.com",
    projectId: "assignment-11-999ed",
    storageBucket: "assignment-11-999ed.appspot.com",
    messagingSenderId: "1005752622810",
    appId: "1:1005752622810:web:ad679d7dc8da48b0dbcfe3"
  };

  export default firebaseConfig;